module.exports = __webpack_public_path__ + "static/media/Brightly_ios_1.18d12b2f.jpg";